// Brands mock data. Backend: replace via brandsService.getBrands()
export const BRANDS = [
  {
    id: "brand-neptec",
    name: "NEPTEC",
    slug: "neptec",
    fullName: "NEPTEC",
    website: "https://www.neptec.de/",
    description:
      "Neptec designs advanced ultrapure and pure water purification systems engineered for demanding laboratory and clinical applications.",
    categories: ["water-purification-systems"],
  },
  {
    id: "brand-eurping",
    name: "EURPING",
    slug: "eurping",
    fullName: "EURPING",
    website: "https://www.eurping.com/",
    description:
      "Eurping delivers laboratory glassware washing solutions built for reliable, repeatable cleaning performance.",
    categories: ["glassware-washers"],
  },
  {
    id: "brand-labtech",
    name: "LabTech",
    slug: "labtech",
    fullName: "LabTech",
    website: "https://labtechsrl.com/en/",
    description:
      "LabTech provides a broad portfolio of laboratory instruments and solutions for research and analytical laboratories.",
    categories: [],
  },
  {
    id: "brand-ohaus",
    name: "Ohaus",
    slug: "ohaus",
    fullName: "Ohaus",
    website: "https://asiapacific.ohaus.com/en-ap/",
    description:
      "Ohaus is a global manufacturer of precision balances and laboratory weighing instruments trusted by laboratories worldwide.",
    categories: ["balances"],
  },
  {
    id: "brand-haier",
    name: "Haier Biomedical",
    slug: "haier-biomedical",
    fullName: "Haier Biomedical",
    website: "https://www.haierbiomedical.co.uk/",
    description:
      "Haier Biomedical specialises in cold chain, storage and biomedical laboratory technologies.",
    categories: [],
  },
  {
    id: "brand-kubota",
    name: "Kubota",
    slug: "kubota",
    fullName: "Kubota",
    website: "https://www.centrifuge.jp/",
    description:
      "Kubota manufactures laboratory centrifuges and separation equipment for scientific and clinical use.",
    categories: [],
  },
];

export const getBrandBySlug = (slug) => BRANDS.find((b) => b.slug === slug);
